import { render, staticRenderFns } from "./normalTree.vue?vue&type=template&id=1f789d51&"
import script from "./normalTree.vue?vue&type=script&lang=js&"
export * from "./normalTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports